import { getLearningApiClient } from "./apiClient";
import { ILearning } from "./interfaces";
import { getLearningPathDetailsBuilder } from "./getLearningPathDetails";
import { getLearningCoursesBuilder } from "./getLearningCourses";
import { getLearningGradesBuilder } from "./getLearningGrades";
import { getLearningExamsBuilder } from "./getLearningExams";
import { getLearningPathItemsBuilder } from "./getLearningPathItem";
import { getLearningPathModulesBuilder } from "./getLearningPathModules";
import { getLearningModuleDetailsBuilder } from "./getLearningModuleDetails";
import { getLearningConceptDetailsBuilder } from "./getLearningConceptDetails";
import { getLearningMaterialsBuilder } from "./getLearningMaterials";
import { getLearningMaterialDetailsBuilder } from "./getMaterialDetails";
import { getContentBySlugBuilder } from "./getContentBySlug";
import { getLearningConceptParentBuilder } from "./getLearningConceptParent";

export function getLearningApiClientFunctions(options?: {
  token?: string;
}): IKunduzApiClient {
  const apiClient = getLearningApiClient({ token: options?.token });

  const functions = {
    getLearningCourses: getLearningCoursesBuilder(apiClient),
    getLearningGrades: getLearningGradesBuilder(apiClient),
    getLearningExams: getLearningExamsBuilder(apiClient),
    getLearningPathItems: getLearningPathItemsBuilder(apiClient),
    getLearningPathDetails: getLearningPathDetailsBuilder(apiClient),
    getLearningPathModules: getLearningPathModulesBuilder(apiClient),
    getLearningModuleDetails: getLearningModuleDetailsBuilder(apiClient),
    getLearningConceptDetails: getLearningConceptDetailsBuilder(apiClient),
    getLearningMaterials: getLearningMaterialsBuilder(apiClient),
    getLearningMaterialDetails: getLearningMaterialDetailsBuilder(apiClient),
    getContentBySlug: getContentBySlugBuilder(apiClient),
    getLearningConceptParent: getLearningConceptParentBuilder(apiClient),
  };

  return functions;
}

export interface IKunduzApiClient {
  getLearningCourses(): Promise<ILearning.LearningFilterMenuItem[] | null>;
  getLearningGrades(): Promise<ILearning.LearningFilterMenuItem[] | null>;
  getLearningExams(): Promise<ILearning.LearningFilterMenuItem[] | null>;
  getLearningPathItems(options: {
    slug: string;
    page: number;
    size: number;
  }): Promise<ILearning.LearningPathItem[] | null>;
  getLearningPathModules(options: {
    id: number;
    page: number;
    size: number;
  }): Promise<ILearning.LearningPathModule[] | null>;
  getLearningModuleDetails(
    id: number
  ): Promise<ILearning.LearningModuleDetails | null>;
  getLearningConceptDetails(
    id: number
  ): Promise<ILearning.LearningConceptByConcept | null>;
  getLearningMaterials(
    id: number
  ): Promise<ILearning.LearningMaterialByConcept[] | null>;
  getLearningMaterialDetails(
    id: number
  ): Promise<ILearning.MaterialResponse | null>;
  getLearningPathDetails(
    id: number
  ): Promise<ILearning.LearningPathDetails | null>;
  getContentBySlug<T>(
    type: string,
    slug: string,
    params?: {
      full_slug?: string;
      page?: number;
      size?: number;
    }
  ): Promise<T | null>;
  getLearningConceptParent: (
    id: number
  ) => Promise<ILearning.LectureVideo | null>;
}
